<p-confirmDialog key="photoConfirmDialog" header="Photo Action Confirmation"
  icon="pi pi-exclamation-triangle"></p-confirmDialog>
  <div class="h-100">
    <p-toast #uploadToast key="uploadToast"></p-toast>
    <p-fileUpload [disabled]="viewOnly" [customUpload]="true" (onSelect)="onFileSelect($event)"
      [multiple]="true" accept="image/*,.heic" [previewWidth]="200" mode="advanced" [showUploadButton]="false"
      [showCancelButton]="false" [style]="{ width: '100%', height: '100%' }">

      <ng-template pTemplate="toolbar">
        <!-- <p-button icon="pi pi-upload" iconPos="left" label="Upload/Save" (onClick)="onUpload($event)"
          [disabled]="saveDisabled"></p-button> -->
        <p-button class="pull-right" icon="pi pi-sort-alt" iconPos="left" label="Sort by Label"
          (onClick)="arrange($event, true)" [disabled]="viewOnly || job && job.inspectionPhotos && !job.inspectionPhotos.length"></p-button>
      </ng-template>

      <ng-template pTemplate="content">
        <div *ngIf="!isLoading && job.inspectionPhotos.length > 0" class="w-100 h-100">
          <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
            <div class="flex flex-row flex-wrap justify-content-start align-content-center gap-2 row-gap-2 photo-upload-content"
              dndDropzone [dndHorizontal]="true" dndEffectAllowed="move" (dndDrop)="onDrop($event)" [dndDisableDropIf]="viewOnly">
              <!-- Placeholder for drag-and-drop -->
              <div class="flex-none placeholder-style" dndPlaceholderRef></div>
  
              <!-- Photo item -->
              <div class="image-tile flex flex-wrap flex-column justify-content-center align-content-center align-items-center bg-white shadow-2 pt-2 px-1"
                *ngFor="let photo of job.inspectionPhotos; let i = index;" [dndDraggable]="photo" dndEffectAllowed="move">
                <!-- Image Tile with Background -->
                <div class="border-round image-container">
                  <img class="draggable-item" title="Photo" [src]="photo.objectUrl" (click)="editPhoto(photo, i)" />
                </div>
                <div class="drag-image-ref border-round" dndDragImageRef>
                  <img class="drag-image" [src]="photo.objectUrl" title="Photo" />
                </div>
  
                <!-- Progress bar -->
                <div class="w-full justify-content-center align-content-center pt-0">
                  <!-- <progressbar [animate]="false" [value]="file.progress" type="info">
                    <b>{{ file.progress }}%</b>
                  </progressbar> -->
                  <div *ngIf="photo.isValid" class="upload-success">
                    <div class="flex flex-column justify-content-center w-100">
                      <div class="max-h-2rem text-sm flex align-items-start text-ellipsis item"  [pTooltip]="photo.name">
                        {{ photo.name }}
                      </div>
                      <div class="flex flex-nowrap gap-2 w-100 block">
                        <div class="flex align-items-center">
                          <i class="pi pi-check-circle"></i>
                        </div>
                        <div class="flex align-items-center">
                          <span>Uploaded</span>
                        </div> 
                        <div class="flex align-items-center max-h-2rem text-xs">
                          {{ photo.size | formatBytes }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!photo.isValid" class="upload-failure">
                    <div class="flex flex-column justify-content-center w-100">
                      <div class="max-h-2rem text-sm flex align-items-start text-ellipsis item"  [pTooltip]="photo.name">
                        {{ photo.name }}
                      </div>
                      <div class="flex flex-nowrap gap-2 w-100 block">
                        <div class="flex align-items-center">
                          <i class="pi pi-exclamation-triangle"></i>
                        </div>
                        <div class="flex align-items-center">
                          <span>Missing</span>
                        </div> 
                        <div class="flex align-items-center max-h-2rem text-xs">
                          {{ photo.size | formatBytes }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                <!-- Photo label dropdown -->
                <div class="w-full pt-1 custom-dropdown">
                  <p-dropdown class="nodrag w-full" [options]="photoLabels" [(ngModel)]="photo.label"
                    placeholder="Select a photo label..." optionLabel="label" optionValue="value" [showClear]="true"
                    (onChange)="saveLabel(photo, $event)" [disabled]="viewOnly"></p-dropdown>
                </div>
  
                <!-- Action buttons -->
                <div class="w-full flex justify-content-center align-content-center gap-2 pt-1">
                  <button pButton pRipple type="button" icon="pi pi-pencil" (click)="editPhoto(photo, i)"
                    class="p-button-rounded p-button-text p-button-info nodrag" pTooltip="Rotate and crop the photo"
                    tooltipPosition="top" aria-label="Edit photo" [disabled]="viewOnly"></button>
                  <button pButton pRipple type="button" icon="pi pi-trash" (click)="deletePhoto(photo, i)"
                    class="p-button-rounded p-button-text p-button-danger nodrag" pTooltip="Remove the photo"
                    tooltipPosition="top" aria-label="Delete photo" [disabled]="viewOnly"></button>
                </div>
              </div>
            </div>
          </p-scrollPanel>  
        </div>
      </ng-template>
      <ng-template pTemplate="file"> </ng-template>
      <ng-template pTemplate="empty">
        <div class="h-full w-full flex flex-column flex-wrap justify-content-center align-items-center p-8 empty-state">
          <div *ngIf="!isLoading && !job.inspectionPhotos.length; else elseBlock" class="text-5xl text-center text-gray-500 vertical-align-middle empty-state-text">
            No photos have been uploaded yet. Click the choose button to start adding photos.
          </div>
          <ng-template #elseBlock>
            <div class="text-5xl text-center text-gray-500 vertical-align-middle empty-state-text">
              Loading...
            </div>
          </ng-template>
        </div>
      </ng-template>
    </p-fileUpload>
</div>